import NotFoundErrorPage from './NotFoundErrorPageContainer'

export default NotFoundErrorPage
